export const messages = {
en: {
    why: `Why`,
    about: {
        title: `Cool that you're using this tool!`,
        text: `I've built this tool because I like to have insights in my money. 
        I find that I'm better at saving and less stressed about money, if I have everyting in order.
        Hopefully this tool can help you too.`,
    },
    tool: {
        intro: {
            title: `Welcome, hero`,
            text: `Fill out the three steps and receive a simple financial system. Using this system, you'll simply get a little bit richer every month.
             It's completely free and you don't have to leave your email address or stuff like that.
            Based on  
            <a href="https://pfauth.com/financiele-onafhankelijkheid/persoonlijk-financieel-systeem/">this article (Dutch)</a>, with
            some small adjustments by myself.`,
            privacy: `No data is being stored, so your privacy is safe.`,
        },
        wizard: {
            general: {
                nextButton: `Next`,
                backButton: `Back`,
                finishButton: `Generate!`,
            },
            plus: {
                title: `The good`,
                subtitle: `This is coming in`,
                incomeQuestion: `What's your monthly income? This can be your salary,
                        but also other income.`,
                salaryDateQuestion: `On which day of the month do you get your salary paid?`,
            },
            min: {
                title: `The bad`,
                subtitle: `This is going out`,
                costsQuestion: `What costs do you have that occur every month? This can be your rent, insurance and energy bill, 
                    but also your subscriptions.`,
            },
            future: {
                title: `The future`,
                subtitle: `Look to the future!`,
                savingQuestion: `How much do you want to invest in your own future each month? 
                    (you have a maximum of {amount} dollar left. Don't forget that you also have to buy food ;))`,
                investingQuestion: `Would you like to invest a part of this money?`,
                investingButtonYes: `Yes, invest`,
                investingButtonNo: `No, only savings`,
                investing: {
                    intro: `Choose how much of your savings you'd like to invest. 
                        Investments usually have higher returns, but you risk losing (a part of) the money you put in. 
                        The easiest way to start investing is by investing in index funds. 
                        <strong>Make sure you're informed before you start investing!</strong> 
                        Investing in index funds is not hard, but only invest if you find it interesting and are aware of the risks involved.`,
                    readMoreIndex: `Read more about investing in index funds`,
                    indexFundLink: `https://www.thebalance.com/investing-in-index-funds-for-beginners-356318`,
                    sliderSaving: `Only save`,
                    sliderInvesting: `Only invest`,
                    saving: `saving`,
                    investing: `investing`,
                    advancedButton: `Advanced`,
                    expectedReturnRateQuestion: `Expected annual return %:`,
                },
                graphExplainer: `The graph below shows an estimate of the amount of money you have saved over a number of years, including the returns`,
                totalSaved: `Total amount in savings`,
                graphCommentInvesting: `<em>This graph assumes a savings interest rate of 0%
                and an average stock market return of 8% - 
                <a href="https://wallethacks.com/average-stock-market-return/">source</a>
                </em>`,
                graphCommentSaving: `<em>This graph assumes a savings interest rate of 0%</em>`,
                graphPrefix: `$ `,
                graphDecimal: `.`,
                graphThousands: `,`,
            },
        }
    },
    advice: {
        adviceTitle: `Your advice`,
        systemTitle: `Your system`,
        currencySign: `$`,
        steps: {
            step1: {
                text: `Make sure you've got the following 4 bank accounts: `,
                expandedText: `<ul>
                                    <li>Checking account (this will be your Base account)</li>
                                    <li>Checking account (this will be your Utilities account)</li>
                                    <li>Checking account (this will be your Allowance account)</li>
                                    <li>Savings account that can be split up into separate goals</li>
                                </ul>
                                <p>
                                    You probably already got a checking account and a savings account. The other 2 checking account can be opened with your bank.
                                     Most banks charge a little extra for each checking account, but you'll easily earn this money back by having good insight in
                                      your money! Make sure you have a savings account that can be split up into separate goals, for example for
                                       emergencies, holidays or charity. Not all banks provide this service.
                                    By opening a savings account with a different bank than your checking account, you can add an
                                     extra mental barrier to prevent yourself from withdrawing money
                                </p>`,
            },
            step2: {
                text: `Also open an investment account`,
                expandedText: `You can do this with a broker. Most banks also offer investment accounts. This is of course the easiest way (but it can be more expensive).`,
            },
            step3: {
                text: `Make sure your salary and other income is deposited into your Base account`,
                expandedText: `You can update your bank account number with your employer.`,
            },
            step4: {
                text: `Make sure your monthly recurring expenses will be withdrawn from your Utilities account.`,
                expandedText: `You can do this by updating your bank account number with the companies that withdraw money from your account each month. 
                Most of the time, you can do this easily on their website. If you transfer the rent by yourself, make this into an automatic transfer from your Utilities account.`,
            },
            step5: {
                text: `Set up three automatic transfers on the {payDate} of the month:`,
                expandedText: `<ul>
                                    <li>Base account -> Utilities account: $ {costs}</li>
                                    <li>Base account -> Savings account: $ {savingAmount}</li>
                                    <li>Base account -> Allowance account: $ {restAmount}</li>
                                </ul>
                                <p>You can easily do this in your online banking environment by setting up a periodical transfer</p>`,
            },
            step6: {
                text: `Set up an automatic transfer on the {payDate} of the month from your Base account to your investment account: $ {investingAmount}`,
                expandedText: `You can easily do this in your online banking environment by setting up a periodical transfer`,
            },
            step7: {
                text: `Invest the money from your Investment account once a month in a cheap, broad index fund (such as VWRL)`,
                expandedText: `Some brokers have the option of doing this automatically. If that's the case, make sure you automatically invest on the {investingDate} of the month.`,
            },
            step8: {
                text: `Split up your Savings account into separate goals`,
                expandedText: `Make some goals on your Savings account. For example: "Emergencies", "Holiday", 
                "Charity". Set a target amount on each goal, and fill them up as you see fit. If all goals are filled up to their target amount,
                 you could increase your monthly investment amount. It's always a good idea to have a couple of month's worth of living
                  expenses in your Savings account, as this makes you less dependent on your employer.`,
            },
        },
        blocks: {
            block0: {
                name: `Income`,
            },
            block1: {
                name: `Base account`,
                subtext: `The center`
            },
            block2: {
                name: `Allowance account`,
                subtext: `You can spend this freely`
            },
            block3: {
                name: `Utilities account`,
                subtext: `Your monthly recurring costs will be withdrawn from here`
            },
            block4: {
                name: `Savings account`,
                subtext: `Here you've got money for every situation that life throws at you`
            },
            block5: {
                name: `Investment account`,
                subtext: `Your wealth grows here`
            },
            block6: {
                name: `Monthly costs`,
            },
        },
        endText: `<strong>Great job!</strong> 
        You're now saving automatically, this makes you a little bit richer every month. 
        You also don't have to worry about random utility/subscription costs that get withdrawn from your account during the month. 
        <strong>You are free to spend all the money ({restAmount} dollar) in your Allowance account, without any worries! :)
        </strong>`,
        donateText: `If you like this tool (or if you're just in a happy mood), 
        you can make me super duper happy with a cup of coffee:`
    }
},











nl: {
    why: `Waarom`,
    about: {
        title: `Leuk dat je deze tool gebruikt!`,
        text: `Ik heb deze tool gebouwd omdat ik zelf graag overzicht wil hebben in m'n geld. 
            Ik heb gemerkt dat ik beter spaar en geen stress heb over geld, als ik alles mooi op een rijtje heb. 
            Hopelijk heb jij er ook wat aan.`,
    },
    tool: {
        intro: {
            title: `Welkom, held`,
            text: `Vul de drie stappen in en krijg een simpel financieel systeem. Door dit systeem word je elke maand op 
            een simpele manier steeds iets rijker. Het is gratis en je hoeft geen emailadres achter te laten 
            of andere ongein. Gebaseerd op 
            <a href="https://pfauth.com/financiele-onafhankelijkheid/persoonlijk-financieel-systeem/">dit artikel</a>, met
            wat kleine aanpassingen die ik zelf handig vind.`,
            privacy: `Er wordt geen data opgeslagen, dus je privacy is gewaarborgd.`,
        },
        wizard: {
            general: {
                nextButton: `Volgende`,
                backButton: `Terug`,
                finishButton: `Genereer!`,
            },
            plus: {
                title: `De plus`,
                subtitle: `Dit komt er binnen`,
                incomeQuestion: `Wat komt er maandelijks op je rekening binnen? Denk hierbij aan je salaris,
                        maar ook bijvoorbeeld toeslagen.`,
                salaryDateQuestion: `Op welke dag van de maand komt je salaris binnen?`,
            },
            min: {
                title: `De min`,
                subtitle: `Dit gaat eruit`,
                costsQuestion: `Welke vaste lasten heb je elke maand? Denk hierbij aan huur, 
                    verzekeringen en energiekosten, maar ook bijvoorbeeld aan abonnementen.`,
            },
            future: {
                title: `De toekomst`,
                subtitle: `Kijk naar de toekomst!`,
                savingQuestion: `Hoeveel wil je per maand investeren in je eigen toekomst? 
                    (je hebt maximaal {amount} euro over. Denk eraan dat je ook nog eten moet kopen ;))`,
                investingQuestion: `Wil je een deel hiervan beleggen?`,
                investingButtonYes: `Ja, ook beleggen`,
                investingButtonNo: `Nee, alleen sparen`,
                investing: {
                    intro: `Kies hier hoeveel van je spaargeld je wilt beleggen. 
                        Beleggingen hebben een hoger rendement, maar je loopt het risico (een deel van) je geld te verliezen. 
                        De makkelijkste manier om te beleggen is indexbeleggen. 
                        <strong>Zorg dat je je goed inleest voordat je gaat beleggen!</strong> 
                        Indexbeleggen is niet heel ingewikkeld, maar ga alleen beleggen als je het interessant vindt en 
                        je bewust bent van het risico.`,
                    readMoreIndex: `Lees hier meer over indexbeleggen`,
                    indexFundLink: `https://www.financieelonafhankelijkblog.nl/beleggen-voor-beginners`,
                    sliderSaving: `Volledig sparen`,
                    sliderInvesting: `Volledig beleggen`,
                    saving: `sparen`,
                    investing: `beleggen`,
                    advancedButton: `Geavanceerd`,
                    expectedReturnRateQuestion: `Verwacht % rendement per jaar:`,
                },
                graphExplainer: `In het grafiekje hieronder kun je een inschatting zien van de hoeveelheid geld
                    die je over een aantal jaar hebt gespaard, inclusief rendement`,
                totalSaved: `Totaal gespaard`,
                graphCommentInvesting: `<em>Bij deze grafiek is uitgegaan van een spaarrente van 0%
                en een beursrendement van gemiddeld 8% per jaar - 
                <a href="https://beleggen.info/beleggen/gemiddeld-rendement">bron</a>
                </em>`,
                graphCommentSaving: `<em>Bij deze grafiek is uitgegaan van een spaarrente van 0%</em>`,
                graphPrefix: `€ `,
                graphDecimal: `,`,
                graphThousands: `.`,
            },
        }
    },
    advice: {
        adviceTitle: `Je advies`,
        systemTitle: `Je systeem`,
        currencySign: `€`,
        steps: {
            step1: {
                text: `Zorg dat je de volgende 4 rekeningen hebt: `,
                expandedText: `<ul>
                                    <li>Betaalrekening (dit wordt je Basisrekening)</li>
                                    <li>Betaalrekening (dit wordt je Vaste-lasten-rekening)</li>
                                    <li>Betaalrekening (dit wordt je Zakgeldrekening)</li>
                                    <li>Spaarrekening waarin je potjes kunt aanmaken</li>
                                </ul>
                                <p>
                                    Waarschijnlijk heb je al een betaalrekening en een spaarrekening. Je kunt de andere 2 rekeningen openen 
                                    bij je bank. Vaak betaal je een klein beetje extra per rekening, maar deze kosten heb je zo terug verdiend 
                                    als je overzicht hebt in je geldzaken! Zorg ervoor dat je een spaarrekening hebt waar je potjes op kunt 
                                    aanmaken, bijvoorbeeld voor vakantie, noodgevallen en goede doelen. Dit kan onder andere bij ING. 
                                    Door je Spaarrekening bij een andere bank te openen dan je betaalrekeningen, kun je de (mentale) drempel om 
                                    er zomaar geld vanaf te halen verhogen
                                </p>`,
            },
            step2: {
                text: `Open ook een beleggingsrekening`,
                expandedText: `Dit kun je doen bij een broker zoals De Giro, Binck of Meesman. Bij veel banken kun 
                    je ook een beleggingsrekening openen. Dit is uiteraard de makkelijkste (maar soms ook wat duurdere) manier.`,
            },
            step3: {
                text: `Zorg dat je salaris en toeslagen (en eventuele andere inkomsten) op je Basisrekening worden gestort`,
                expandedText: `Je kunt je rekeningnummer wijzigen bij je werkgever en de belastingdienst (voor toeslagen)`,
            },
            step4: {
                text: `Zorg dat je vaste lasten worden afgeschreven van je Vaste-lasten-rekening.`,
                expandedText: `Dit kun je doen door het rekeningnummer door te geven aan de bedrijven die elke maand geld
                 afschrijven. Vaak gaat dit gemakkelijk via hun website. Als je bijvoorbeeld de huur zelf
                  overmaakt, zorg dan dat deze via een automatische overschrijving van je Vaste-lasten-rekening afgaat.`,
            },
            step5: {
                text: `Stel drie automatische overschrijvingen in op de {payDate}e van de maand:`,
                expandedText: `<ul>
                                    <li>Basisrekening -> Vaste-lasten-rekening: € {costs}</li>
                                    <li>Basisrekening -> Spaarrekening: € {savingAmount}</li>
                                    <li>Basisrekening -> Zakgeldrekening: € {restAmount}</li>
                                </ul>
                                <p>Dit kun je gemakkelijk doen in je internetbankieren met een periodieke overboeking</p>`,
            },
            step6: {
                text: `Stel een automatische overschrijving in op de {payDate}e van de maand van je Basisrekening naar je Beleggingsrekening: € {investingAmount}`,
                expandedText: `Dit kun je gemakkelijk doen in je internetbankieren met een periodieke overboeking`,
            },
            step7: {
                text: `Investeer het geld van je Beleggingsrekening 1 keer per maand in een goedkoop, breed indexfonds (zoals VWRL)`,
                expandedText: `Bij sommige brokers (zoals Meesman) kun je dit ook automatisch laten doen. Zorg dan dat je automatisch inlegt op de {investingDate}e van de maand.`,
            },
            step8: {
                text: `Verdeel je Spaarrekening in potjes`,
                expandedText: `Maak een aantal potjes aan op je spaarrekening. Bijvoorbeeld: "Noodgevallen", "Vakantie", 
                "Goede doelen". Geef deze potjes een doelbedrag en vul ze naar eigen inzicht aan. Als deze potjes gevuld
                 zijn, zou je het bedrag dat je maandelijks belegt kunnen verhogen. Het kan ook altijd handig zijn om
                  een aantal maanden leefkosten als spaargeld achter de hand te hebben, dan ben je niet meer afhankelijk
                   van je werkgever.`,
            },
        },
        blocks: {
            block0: {
                name: `Inkomsten`,
            },
            block1: {
                name: `Basisrekening`,
                subtext: `Het centrum`
            },
            block2: {
                name: `Zakgeldrekening`,
                subtext: `Dit kun je vrij uitgeven`
            },
            block3: {
                name: `Vaste-lasten-rekening`,
                subtext: `Hier gaan je vaste lasten vanaf`
            },
            block4: {
                name: `Spaarrekening`,
                subtext: `Hier heb je voor elke situatie een potje klaarstaan`
            },
            block5: {
                name: `Beleggingsrekening`,
                subtext: `Hier groeit je rijkdom`
            },
            block6: {
                name: `Vaste lasten`,
            },
        },
        endText: `<strong>Lekker bezig!</strong> 
        Je spaart nu automatisch, waardoor je iedere maand weer iets rijker bent. 
        Je hoeft je ook geen zorgen meer te maken over willekeurige afschrijvingen 
        voor vaste lasten halverwege de maand. 
        Het geld dat op je zakgeldrekening staat ({restAmount} euro) kun je 
        <strong>zorgeloos uitgeven! :)</strong>`,
        donateText: `Vind je dit een handig tooltje (of ben je gewoon in een vrolijke bui), 
        dan kun je me super blij maken met een kopje koffie:`
    }
}
}
